
export class ShippingCost {

  public id: string;
  public shippingCostID: number;
  public shippingMethodID: number;
  public cityFromID: string;
  public cityToID: string;
  public cost: number;
  public freeLimit: number;
  public weight: number;
  //Dimensions
  public height: number;
  public width: number;
  public length: number;

}



// WEBPACK FOOTER //
// ./src/app/models/shippment/shipping-cost.model.ts